<template>
  <div class="d-flex" :class="{ trashed: cov.trashed }">
    <v-icon
      size="64"
      v-if="cov.trashed"
      color="colorSemanticStateRed100 darken-1"
      class="trash-icon-bg align-self-center ml-n2"
    >
      mdi-delete
    </v-icon>
    <div v-if="movable" class="cov-bar"></div>
    <div class="main-content flex-grow-1 py-1 px-4">
      <div class="row-one d-flex align-center mb-1">
        <div class="mr-4">{{ cov.legalName }}</div>
        <v-tooltip top v-if="cov.vendorNumber">
          <template v-slot:activator="{ on, attrs }">
            <v-chip label x-small class="mr-4" v-bind="attrs" v-on="on">
              {{ cov.vendorNumber }}
            </v-chip>
          </template>
          <span>Vendor Number</span>
        </v-tooltip>
        <v-spacer />
        <div class="mr-4 text--primary body-2">
          {{ cov.tin | formatTIN(cov.tinType) }}
        </div>
        <v-chip v-if="cov.ptid" small color="colorPtBlue50" class="mr-2">
          <span class="mr-1"><strong>PTID</strong></span>
          <span>{{ cov.ptid }}</span>
        </v-chip>
        <v-chip small color="colorPtBlue50">
          <v-icon left>
            mdi-identifier
          </v-icon>
          {{ cov.id }}
        </v-chip>
      </div>
      <div class="row-two d-flex align-center text--disabled">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">{{ cov.managerName }}</div>
          </template>
          <span>Manager</span>
        </v-tooltip>
        <v-spacer />
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-chip label x-small class="mr-4" v-bind="attrs" v-on="on">
              {{ cov.vendorCategory }}
            </v-chip>
          </template>
          <span>Vendor Category</span>
        </v-tooltip>
        <v-tooltip v-if="cov.createdByOnboarding" top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              size="18"
              class="text--disabled mr-4"
              v-bind="attrs"
              v-on="on"
            >
              mdi-format-list-checks
            </v-icon>
          </template>
          <span>
            This record was created by an onboarding workflow.
          </span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon size="18" class="text--disabled" v-bind="attrs" v-on="on">
              mdi-timetable
            </v-icon>
          </template>
          <span>
            Created
            {{ cov.createTime | formatDate("MM/dd/yyyy hh:mm:ss a") }} by
            {{ cov.createUser }}
            <br />
            Last modified
            {{ cov.lastModTime | formatDate("MM/dd/yyyy hh:mm:ss a") }} by
            {{ cov.lastModUser }}
            <br v-if="cov.trashed" />
            <span v-if="cov.trashed">
              Trashed
              {{ cov.trashTime | formatDate("MM/dd/yyyy hh:mm:ss a") }}
            </span>
          </span>
        </v-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate, formatTIN } from "@/services/format";

export default {
  name: "ClientOwnedVendor",
  props: {
    cov: {},
    movable: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    formatDate,
    formatTIN
  }
};
</script>

<style lang="scss" scoped>
.cov-bar {
  width: 3px;
  margin: 2px;
  background-color: $color-neutrals-navy-150;
}

.trashed {
  background-image: linear-gradient(
    to right,
    $color-semantic-state-red-100 10%,
    white 40%
  );

  .trash-icon-bg {
    position: absolute;
    z-index: 0;
  }

  .main-content {
    z-index: 1;
  }
}
</style>
